<template>
  <div class="common-box contractAddBox">
    <div class="top-box">
      <top-operation-box>
        <div v-if="canEdit">
          <el-button class="plr28" type="primary" @click="save" size="mini"
            >保存</el-button
          >
          <el-button class="plr28" size="mini" @click="back">取消</el-button>
        </div>
        <el-button v-else class="plr28" type="primary" size="mini" @click="back"
          >返回</el-button
        >
      </top-operation-box>
    </div>
    <box-with-title title="附件上传" paddingBottom="4px">
      <div slot="content">
        <UploadAttachments @createFile="createFile" @deleteFile="deleteFile" :fileName="form.attachmentName"/>
      </div>
    </box-with-title>
    <el-form :model="form" :rules="rules" inline ref="form">
      <Interval />
      <box-with-title title="基本信息" paddingBottom="4px">
        <div slot="content">
          <el-form-item label="项目名称：" prop="projectId">
            <el-select
              size="mini"
              v-model="projectObj"
              filterable
              placeholder="请选择所属项目"
              clearable
              reserve-keyword
              :remote="true"
              :remote-method="searchProjectList"
              @visible-change="searchProjectList('')"
              @change="chooseProject"
              value-key="id"
              :disabled="!canEdit"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.projectName"
                :value="item"
              ></el-option>
            </el-select>
            <!-- <el-button @click="addProject" size="mini" type="text"
              >添加</el-button
            > -->
          </el-form-item>
          <el-form-item label="合同号：" prop="contractNumber">
            <el-input
              size="mini"
              :disabled="!canEdit"
              v-model.trim="form.contractNumber"
              placeholder="请输入合同号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="项目地址：" class="input-with-col2">
            <el-input
              size="mini"
              v-model.trim="form.projectAddress"
              placeholder="请输入项目地址"
              clearable
              :disabled="!canEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="合同来源：" prop="contractSourceCode">
            <el-select
              size="mini"
              v-model="contractSourceObj"
              value-key="dictionaryCode"
              @change="chooseContractSource"
              placeholder="请选择合同来源"
              clearable
              :disabled="!canEdit"
            >
              <el-option
                v-for="item in htlyDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="甲方名称：" prop="propertyUnitId">
            <el-select
              size="mini"
              v-model="propertyUnitObj"
              filterable
              placeholder="请选择所属单位"
              clearable
              :disabled="!canEdit"
              reserve-keyword
              :remote="true"
              @change="selectLiftObj"
              :remote-method="searchUnitList"
              @visible-change="searchUnitList('')"
              value-key="id"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item"
              ></el-option>
            </el-select>
            <!-- <el-button @click="addPartyA" size="mini" type="text"
              >添加</el-button
            > -->
          </el-form-item>

          <el-form-item
            label="客户联系人："
            label-width="84px"
            class="label-with-five-word"
            prop="contactPerson"
          >
            <el-input
              size="mini"
              v-model.trim="form.contactPerson"
              placeholder="请输入客户联系人"
              clearable
              :disabled="!canEdit"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="客户联系电话："
            label-width="98px"
            class="label-with-six-word"
            prop="contactTelephone"
          >
            <el-input
              size="mini"
              v-model.trim="form.contactTelephone"
              placeholder="请输入客户联系电话"
              clearable
              :disabled="!canEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="合同类型：" prop="contractTypeCode">
            <el-select
              size="mini"
              v-model="contractTypeObj"
              value-key="dictionaryCode"
              @change="chooseContractType"
              placeholder="请选择合同类型"
              clearable
              :disabled="!canEdit"
            >
              <el-option
                v-for="item in htlxDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="乙方名称：" prop="secondParty">
            <el-input
              size="mini"
              v-model.trim="form.secondParty"
              placeholder="请输入乙方名称"
              clearable
              :disabled="!canEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="签约人：" prop="contractorId">
            <el-select
              size="mini"
              v-model="form.contractorId"
              filterable
              placeholder="请选择用户"
              clearable
              :disabled="!canEdit"
              reserve-keyword
              :remote="true"
              collapse-tags
              :remote-method="searchUserList"
              @visible-change="searchUserList('')"
            >
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.nickname"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电梯数量：" prop="liftNum">
            <el-input
              size="mini"
              v-model.trim="form.liftNum"
              placeholder="请输入电梯数量"
              clearable
              :disabled="!canEdit"
            >
              　<span slot="suffix">台</span>
            </el-input>
          </el-form-item>
          <el-form-item label="服务时间：" prop="startTime">
            <el-date-picker
              v-model="timeObj"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              unlink-panels
              clearable
              :disabled="!canEdit"
              @change="chooseTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注：" class="input-with-col2">
            <el-input
              size="mini"
              v-model.trim="form.remark"
              placeholder="请输入备注"
              clearable
              :disabled="!canEdit"
            ></el-input>
          </el-form-item>
        </div>
      </box-with-title>
      <Interval />
      <box-with-title title="服务内容" paddingBottom="4px">
        <div slot="content">
          <el-form-item label="年检费用：" prop="annualInspectionCode">
            <el-select
              size="mini"
              v-model="annualInspectionObj"
              value-key="dictionaryCode"
              @change="chooseAnnualInspection"
              clearable
              :disabled="!canEdit"
            >
              <el-option
                v-for="item in njfyDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item"
                placeholder="请选择年检费用"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="服务方式：" prop="serviceModeCode">
            <el-select
              size="mini"
              v-model="serviceModeObj"
              value-key="dictionaryCode"
              @change="chooseServiceMode"
              clearable
              :disabled="!canEdit"
            >
              <el-option
                v-for="item in fwfsDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item"
                placeholder="请选择服务方式"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配件金额：">
            <el-input
              size="mini"
              v-model.trim="form.fittingsAmount"
              v-number-only:20="2"
              placeholder="请输入配件金额"
              clearable
              :disabled="!canEdit"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-form-item>
          <el-form-item label="是否驻场：" prop="residentCode">
            <el-select
              size="mini"
              v-model="residentObj"
              value-key="dictionaryCode"
              @change="chooseResident"
              clearable
              :disabled="!canEdit"
            >
              <el-option
                v-for="item in sfzcDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item"
                placeholder="是否驻场"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </box-with-title>
      <Interval />
      <box-with-title title="合同费用" paddingBottom="4px">
        <div slot="content">
          <el-form-item label="合同总额：" prop="contractAmount">
            <el-input
              size="mini"
              v-model.trim="form.contractAmount"
              v-number-only:20="2"
              placeholder="请输入合同总额"
              clearable
              :disabled="!canEdit"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-form-item>
          <el-form-item label="费用明细">
            <el-button size="mini" type="text" @click="handleSetLiftUnitPrice"
              >设置</el-button
            >
          </el-form-item>
          <el-form-item label="支付方式：" prop="paymentModeCode">
            <el-select
              size="mini"
              v-model="paymentModeObj"
              value-key="dictionaryCode"
              @change="choosePaymentMode"
              clearable
              :disabled="!canEdit"
              placeholder="请选择支付方式"
            >
              <el-option
                v-for="item in zffsDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </box-with-title>
      <Interval />
    </el-form>
    <boxfold
      title="收款计划"
      :btnData="['快速生成计划']"
      @boxfoldfun="boxfoldfun"
    >
      <div slot="content">
        <!-- <sales-commission-add :config="config" :commissionPreview="commissionPreview" ref="SalesCommissionAdd"></sales-commission-add> -->
        <PaymentPlan
          :contractId="contractId"
          :contractCollectionPlanList="contractCollectionPlanList"
          @confirm="paymentPlanConfirm"
        />
      </div>
    </boxfold>
    <AddProject v-if="showAddProject" @cancel="showAddProject = false" />
    <AddClient
      :clientForm="clientForm"
      v-if="showAddPartyA"
      @cancel="showAddPartyA = false"
      @confirm="addPartyAConfirm"
    />
    <SettingPrice
      :canEdit="canEdit"
      :liftUnitPriceList="form.liftUnitPriceList"
      :otherCostDTOList="form.otherCostDTOList"
      v-if="liftPriceVisible"
      :contractAmount="form.contractAmount"
      @confirm="liftPriceConfirm"
      @cancel="liftPriceVisible = false"
    />
    <QuicklyGenerate
      @confirm="confirmQuicklyGenerate"
      :startTime="timeObj[0]"
      :endTime="timeObj[1]"
      v-if="showQuicklyGenerate"
      @cancel="showQuicklyGenerate = false"
    />
  </div>
</template>

<script>
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import { getUnitSimpleList } from "@/api/ProjectManagement";
import { mapState } from "vuex";
import AddProject from "./AddProject";
import AddClient from "./AddClient";
import SettingPrice from "./SettingPrice";
import PaymentPlan from "./PaymentPlan";
import QuicklyGenerate from "./QuicklyGenerate";
import {
  addContract,
  updateContract,
  getContractDetail,
  getCollectionList,
  createContractCollectionPlan,
} from "@/api/ContractManagement";
import { getUserSimpleList } from "@/api/MaintenancePlan";
import UploadAttachments from "@/components/UploadAttachments"

export default {
  data() {
    return {
      form: {
        annualInspectionCode: "", //年检费用code
        annualInspectionName: "", //年检费用name

        attachment: "", //附件地址
        attachmentName: "", //附件名称
        contactPerson: "", //联系人
        contactTelephone: "", //联系电话
        contractAmount: "", //合同总金额
        contractCollectionPlanList: [], //回款计划列表
        contractNumber: "", //合同编号

        contractSourceCode: "", //合同来源code
        contractSourceName: "", //合同来源name

        contractTypeCode: "", //合同类型code
        contractTypeName: "", //合同类型name

        contractorId: "", //签约人id
        endTime: "", //结束时间
        fittingsAmount: "", //配件金额
        liftNum: "", //电梯数量
        liftUnitPriceList: [], //费用详情-电梯单价
        otherCostDTOList: [], //费用详情-其他费用
        parentId: "", //续签合同的原合同id

        paymentModeCode: "", //支付方式code
        paymentModeName: "", //支付方式name

        projectAddress: "", //项目地址

        projectId: "", //项目id
        projectName: "", //项目名称

        propertyUnitId: "", //（甲方）使用单位id
        propertyUnitName: "", //（甲方）使用单位名称
        remark: "", //备注

        residentCode: "", //是否驻场code
        residentName: "", //是否驻场name

        secondParty: "", //乙方

        serviceModeCode: "", //服务方式code
        serviceModeName: "", //服务方式name
        startTime: "", //开始时间
      },
      annualInspectionObj: null,
      contractSourceObj: null,
      contractTypeObj: null,
      paymentModeObj: null,
      projectObj: null,
      propertyUnitObj: null,
      residentObj: null,
      serviceModeObj: null,
      timeObj: [],
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择项目名称",
            trigger: "change",
          },
        ],
        contractNumber: [
          {
            required: true,
            message: "请输入合同号",
            trigger: "blur",
          },
        ],
        contractAmount: [
          {
            required: true,
            message: "请输入合同总额",
            trigger: "blur",
          },
        ],
        contractSourceCode: [
          {
            required: true,
            message: "请选择合同来源",
            trigger: "change",
          },
        ],
        contractTypeCode: [
          {
            required: true,
            message: "请选择合同类型",
            trigger: "change",
          },
        ],
        secondParty: [
          {
            required: true,
            message: "请输入乙方名称",
            trigger: "blur",
          },
        ],
        liftNum: [
          {
            required: true,
            message: "请输入电梯数量",
            trigger: "blur",
          },
        ],
        contactPerson: [
          {
            required: true,
            message: "请输入客户联系人",
            trigger: "blur",
          },
        ],
        contactTelephone: [
          {
            required: true,
            message: "请输入客户联系电话",
            trigger: "blur",
          },
        ],
        propertyUnitId: [
          {
            required: true,
            message: "请选择甲方名称",
            trigger: "change",
          },
        ],
        annualInspectionCode: [
          {
            required: true,
            message: "请选择年检费用",
            trigger: "change",
          },
        ],
        serviceModeCode: [
          {
            required: true,
            message: "请选择服务方式",
            trigger: "change",
          },
        ],
        residentCode: [
          {
            required: true,
            message: "请选择是否驻场",
            trigger: "change",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择服务时间",
            trigger: "change",
          },
        ],
        paymentModeCode: [
          {
            required: true,
            message: "请选择支付方式",
            trigger: "change",
          },
        ],
        contractorId: [
          {
            required: true,
            message: "请选择签约人",
            trigger: "change",
          },
        ],
      },
      projectList: [],
      showAddProject: false,
      showAddPartyA: false,
      liftPriceVisible: false,
      clientForm: {
        id: null,
        clientName: null,
        contactList: [],
      },
      unitList: [],
      userList: [],
      canEdit: true,
      contractCollectionPlanList: [],
      contractId: null,
      contractNumber: null,
      showQuicklyGenerate: false,
    };
  },
  components: {
    AddProject,
    AddClient,
    SettingPrice,
    PaymentPlan,
    QuicklyGenerate,
    UploadAttachments
  },
  computed: {
    ...mapState("common/dictionary", [
      "htlyDicts",
      "htlxDicts",
      "njfyDicts",
      "zffsDicts",
      "sfzcDicts",
      "fwfsDicts",
    ]),
  },
  created() {
    if (this.$route.query.id || this.$route.query.contractNumber) {
      this.contractId = this.$route.query.id;
      this.contractNumber = this.$route.query.contractNumber;
      this.searchProjectList();
      this.searchUnitList();
      this.getContractDetail();
      this.searchUserList();
    }
    this.canEdit = this.$route.query.canEdit;
  },
  methods: {
    async getContractDetail() {
      const res = await getContractDetail(
      {contractId: this.contractId ,
      contractNumber: this.contractNumber}
      );
      if (res.code === 200) {
        this.form = { ...res.data };
        this.contractId = this.form.contractId;
        this.getCollectionList();
        if (this.form.projectId) {
          this.projectObj = {
            projectName: this.form.projectName,
            id: this.form.projectId,
          };
        }

        if (this.form.contractSourceCode) {
          this.contractSourceObj = {
            dictionaryCode: this.form.contractSourceCode,
            dictionaryValue: this.form.contractSourceName,
          };
        }

        if (this.form.propertyUnitId) {
          this.propertyUnitObj = {
            id: this.form.propertyUnitId,
            unitName: this.form.propertyUnitName,
          };
        }

        if (this.form.contractTypeCode) {
          this.contractTypeObj = {
            dictionaryCode: this.form.contractTypeCode,
            dictionaryValue: this.form.contractTypeName,
          };
        }

        if (this.form.annualInspectionCode) {
          this.annualInspectionObj = {
            dictionaryCode: this.form.annualInspectionCode,
            dictionaryValue: this.form.annualInspectionName,
          };
        }

        if (this.form.serviceModeCode) {
          this.serviceModeObj = {
            dictionaryCode: this.form.serviceModeCode,
            dictionaryValue: this.form.serviceModeName,
          };
        }

        if (this.form.residentCode) {
          this.residentObj = {
            dictionaryCode: this.form.residentCode,
            dictionaryValue: this.form.residentName,
          };
        }

        if (this.form.paymentModeCode) {
          this.paymentModeObj = {
            dictionaryCode: this.form.paymentModeCode,
            dictionaryValue: this.form.paymentModeName,
          };
        }

        if (this.form.startTime) {
          this.timeObj = [this.form.startTime, this.form.endTime];
        }
      }
    },
    save() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let params = { ...this.form };
          params.fittingsAmount = parseFloat(params.fittingsAmount);
          params.contractAmount = parseFloat(params.contractAmount);
          params.liftNum = parseInt(params.liftNum);
          let res = null;
          if (this.contractId) {
            res = await updateContract(params);
          } else {
            res = await addContract(params);
          }
          if (res.code === 200) {
            let message = "添加成功";
            if (this.contractId) {
              message = "编辑成功";
            }
            this.$message.success(message);
            this.back("1");
          }
        }
      });
    },
    back(f = "0") {
      this.$router.replace({
        name: "ContractManagement",
        params: {
          refresh: f,
        },
      });
    },
    boxfoldfun() {
      if (!this.timeObj || !this.timeObj.length) {
        this.$message.warning("请选择服务时间");
        return;
      }
      if (!this.form.contractAmount) {
        this.$message.warning("请输入合同价格");
        return;
      }
      this.showQuicklyGenerate = true;
    },
    handleSearchListData() {},
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    addProject() {
      this.showAddProject = true;
    },
    addPartyA() {
      this.clientForm = {
        id: null,
        clientName: null,
        contactList: [],
      };
      this.showAddPartyA = true;
    },
    handleGetClientList() {},
    handleGetClientContactsList() {},
    addPartyAConfirm(clientId) {
      if (clientId) {
        this.handleGetClientList();
        this.form.firstPartyId = clientId;
      }
      this.handleGetClientContactsList(this.form.firstPartyId);
      this.addClientVisible = false;
    },
    handleAddClientContracts() {
      if (this.form.firstPartyId) {
        const client = find(
          this.clientList,
          (o) => o.id === this.form.firstPartyId
        );
        if (!client) {
          return;
        }
        this.clientForm = {
          id: client.id,
          clientName: client.clientName,
          contactList: [
            {
              contactUserName: null,
              contactUserPhone: null,
            },
          ],
        };
        getClientContactsList(client.id).then((res) => {
          if (res) {
            if (res && res.length > 0) {
              this.clientForm.contactList = [...res];
            } else {
              this.clientForm.contactList = [
                {
                  contactUserName: null,
                  contactUserPhone: null,
                },
              ];
            }
          }
          this.showAddPartyA = true;
        });
      }
    },
    handleSetLiftUnitPrice() {
      this.liftPriceVisible = true;
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    selectLiftObj(item) {
      if (item) {
        this.form.propertyUnitId = item.id;
        this.form.propertyUnitName = item.unitName;
      } else {
        this.form.propertyUnitId = "";
        this.form.propertyUnitName = "";
      }
    },
    chooseContractSource(item) {
      if (item) {
        this.form.contractSourceCode = item.dictionaryCode;
        this.form.contractSourceName = item.dictionaryValue;
      } else {
        this.form.contractSourceCode = "";
        this.form.contractSourceName = "";
      }
    },
    chooseProject(item) {
      if (item) {
        this.form.projectId = item.id;
        this.form.projectName = item.projectName;
      } else {
        this.form.projectId = "";
        this.form.projectName = "";
      }
    },
    chooseContractType(item) {
      if (item) {
        this.form.contractTypeCode = item.dictionaryCode;
        this.form.contractTypeName = item.dictionaryValue;
      } else {
        this.form.contractTypeCode = "";
        this.form.contractTypeName = "";
      }
    },
    chooseTime(time) {
      if (time && time.length) {
        this.form.startTime = time[0];
        this.form.endTime = time[1];
      } else {
        this.form.startTime = "";
        this.form.endTime = "";
      }
    },
    chooseAnnualInspection(item) {
      if (item) {
        this.form.annualInspectionCode = item.dictionaryCode;
        this.form.annualInspectionName = item.dictionaryValue;
      } else {
        this.form.annualInspectionCode = "";
        this.form.annualInspectionName = "";
      }
    },
    chooseServiceMode(item) {
      if (item) {
        this.form.serviceModeCode = item.dictionaryCode;
        this.form.serviceModeName = item.dictionaryValue;
      } else {
        this.form.serviceModeCode = "";
        this.form.serviceModeName = "";
      }
    },
    chooseResident(item) {
      if (item) {
        this.form.residentCode = item.dictionaryCode;
        this.form.residentName = item.dictionaryValue;
      } else {
        this.form.residentCode = "";
        this.form.residentName = "";
      }
    },
    choosePaymentMode(item) {
      if (item) {
        this.form.paymentModeCode = item.dictionaryCode;
        this.form.paymentModeName = item.dictionaryValue;
      } else {
        this.form.paymentModeCode = "";
        this.form.paymentModeName = "";
      }
    },
    liftPriceConfirm(value) {
      this.form.otherCostDTOList = value.otherCostDTOList;
      this.form.liftUnitPriceList = value.liftUnitPriceList;
      this.liftPriceVisible = false;
    },
    async searchUserList(keyword) {
      const res = await getUserSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.userList = res.data;
      }
    },
    paymentPlanConfirm(val) {
      this.form.contractCollectionPlanList = val;
    },
    async getCollectionList() {
      const res = await getCollectionList({ contractId: this.contractId });
      if (res.code === 200) {
        let arr = res.data.map((item) => {
          return {
            ...item,
            isEditing: false,
          };
        });
        this.contractCollectionPlanList = JSON.parse(JSON.stringify(arr));
      }
    },
    async confirmQuicklyGenerate(val) {
      let params = { ...val };
      params.totalAmount = this.form.contractAmount * 1;
      params.endTime = this.timeObj[1];
      params.firstAmount = params.firstAmount * 1;
      params.dayNum = params.dayNum * 1;
      const res = await createContractCollectionPlan(params);
      if (res.code === 200) {
        let arr = res.data.map((item) => {
          return {
            ...item,
            isEditing: false,
            receivableTime: item.receivableTime.substr(0, 10),
          };
        });
        this.contractCollectionPlanList = JSON.parse(JSON.stringify(arr));
        this.form.contractCollectionPlanList = JSON.parse(JSON.stringify(arr));
        this.showQuicklyGenerate = false;
      }
    },
    createFile(res) {
      this.form.attachment = res.reourceAddress;
      this.form.attachmentName = res.fileName;
    },
    deleteFile() {
      this.form.attachment = '';
      this.form.attachmentName = '';
    }
  },
};
</script>

<style lang="scss">
.contractAddBox {
  .contrantAddBoxAdd {
    .el-select {
      width: 160px;
    }
  }
  .contrantAddBoxAddFive {
    .el-select {
      width: 140px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/ContractAdd.vue